const styles = {
  text: {
    height: '200px'
  },
  deleteButton: {
    marginRight: 'auto !important'
  }
}

export default styles
